import { render, staticRenderFns } from "./click-image-component.vue?vue&type=template&id=3690f5e0&scoped=true&"
import script from "./click-image-component.vue?vue&type=script&lang=ts&"
export * from "./click-image-component.vue?vue&type=script&lang=ts&"
import style0 from "./click-image-component.vue?vue&type=style&index=0&id=3690f5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690f5e0",
  null
  
)

export default component.exports